import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import HeaderComp from '../CommanCom/HeaderComp'
import FooterComp from '../CommanCom/FooterComp'
import LeftComp from '../AppCom/HR/LeftComp'
import PermissionDeniedCom from "../ErrorPage/PermissionDeniedCom"

function HrRoutes({ redirectpath = 'login', children, header_title, menu_id }) {
    const menu_permission = useSelector(state => state.login_Permission.permissions)
    return (
        <div className="user_main_container">

            <HeaderComp />
            <main id="dash_content_area">
                <LeftComp />
                <div id="content_area">
                    {menu_permission.includes(menu_id?.toString()) ? children ? children : <PermissionDeniedCom /> : <PermissionDeniedCom />}
                    <FooterComp />
                </div>
            </main>
        </div>
    )
}

export default HrRoutes
